import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionEnd(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription, classes.textCenter)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description}>
            Introducing the KINOS & TORUS  Sales Force
          </h2>

          <h5>We greatly enjoy our working relationship with TORUS & PARTNERS NETWORK . They are always prepared and proactive, bringing new ideas to the table and executing at a high level. Strategies are well-conceived and always with our interests and objectives in mind.
          </h5>
          <h5>Our unique and advanced sales systems will drive your project towards the results you aim for. From Sales Strategy to Sales Management, our highly-trained team is here to inform the progression. We are happy to enlighten you with more details of each element of our Sales Force's process, and how it connects with the development lifecycle.</h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionEnd);
